import { motion } from 'framer-motion';
import {
  Activity,
  BadgeCheck,
  Syringe,
  Snowflake,
  Globe,
  PlusSquare,
  ShieldCheck,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

interface TrustItem {
  label: string;
  icon: LucideIcon;
}

const TRUST_ITEMS: TrustItem[] = [
  { label: 'HPLC-Verified Purity', icon: Activity },
  { label: 'Lot-Sealed COA', icon: BadgeCheck },
  { label: 'Pre-Filled Pen', icon: Syringe },
  { label: 'Cold-Chain Dispatch', icon: Snowflake },
  { label: 'Ships Worldwide', icon: Globe },
  { label: 'UAE-Sourced', icon: PlusSquare },
  { label: 'Third-Party Tested', icon: ShieldCheck },
];

export default function TrustStrip() {
  return (
    <section className="overflow-hidden border-t border-rp-line bg-rp-paper py-3 md:py-4">
      <motion.div
        className="rp-container"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: '-50px' }}
        transition={{ duration: 0.5, ease: 'easeOut' }}
      >
        <div className="relative -mx-4 overflow-hidden px-4 md:-mx-6 md:px-6">
          <motion.div
            className="flex w-max items-center"
            animate={{ x: ['0%', '-50%'] }}
            transition={{
              repeat: Infinity,
              duration: 30,
              ease: 'linear',
            }}
          >
            {[...Array(2)].map((_, duplicateIndex) => (
              <div
                key={duplicateIndex}
                className="flex shrink-0 items-center"
                aria-hidden={duplicateIndex === 1}
              >
                {TRUST_ITEMS.map(({ label, icon: Icon }) => (
                  <div
                    key={`${duplicateIndex}-${label}`}
                    className="flex shrink-0 items-center gap-2 px-4 md:gap-2.5 md:px-6"
                  >
                    <span className="flex h-5 w-5 items-center justify-center text-rp-forest md:h-6 md:w-6">
                      <Icon size={18} strokeWidth={1.5} aria-hidden="true" />
                    </span>
                    <span className="whitespace-nowrap font-mono text-[10px] font-bold uppercase tracking-[0.08em] text-rp-forest">
                      {label}
                    </span>
                    <span
                      className="mx-3 h-1 w-1 rounded-full bg-rp-line-2 md:mx-5"
                      aria-hidden="true"
                    />
                  </div>
                ))}
              </div>
            ))}
          </motion.div>
        </div>
      </motion.div>
    </section>
  );
}
